
const GetDeliveryConfig = `query Query($id: String!) {
    deliveryConfig(id: $id) {
      id
      name
      description
      deliveryService
      dataType {
        id
        name
        description
      }
      sender {
        id
        name
        description      
      }
      receiver {
        id
        name
        description
      }
      config {
        ... on DeliveryConfigSFTPConfig {
          endpoint
          path
          workingDirectory
          schedule
          window
        }
        ... on DeliveryConfigHTTPConfig {
          endpoint
          path
          method
          HTTPS
          responseValidationRegex
          headers {
            key
            value
          }
          schedule
          window
        }
        ... on DeliveryConfigBlobConfig {
          endpoint
          blobKey
          schedule
          window
        }
      }
    }
  }
  `

module.exports = {
  GetDeliveryConfig,  
}